<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="title" id="title" type="text" pInputText>
            <label for="title">Title</label>
            @for (validation of validationMessages.title; track validation) {
              <span>
                @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="fileName" id="fileName" type="text" pInputText>
            <label for="fileName">File Name</label>
            @for (validation of validationMessages.fileName; track validation) {
              <span>
                @if (form1.get('fileName').hasError(validation.type) && (form1.get('fileName').dirty || form1.get('fileName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="caption" id="caption" type="text" pInputText>
            <label for="caption">Caption</label>
            @for (validation of validationMessages.caption; track validation) {
              <span>
                @if (form1.get('caption').hasError(validation.type) && (form1.get('caption').dirty || form1.get('caption').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="describesType" id="describesType" type="text" pInputText>
            <label for="describesType">Describes Type</label>
            @for (validation of validationMessages.describesType; track validation) {
              <span>
                @if (form1.get('describesType').hasError(validation.type) && (form1.get('describesType').dirty || form1.get('describesType').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="url" id="url" type="text" pInputText>
            <label for="url">URL</label>
            @for (validation of validationMessages.url; track validation) {
              <span>
                @if (form1.get('url').hasError(validation.type) && (form1.get('url').dirty || form1.get('url').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="virtualTourURL" id="virtualTourURL" type="text" pInputText>
            <label for="virtualTourURL">Virtual Tour URL</label>
            @for (validation of validationMessages.virtualTourURL; track validation) {
              <span>
                @if (form1.get('virtualTourURL').hasError(validation.type) && (form1.get('virtualTourURL').dirty || form1.get('virtualTourURL').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="amazonBucketName" id="amazonBucketName" type="text" pInputText>
            <label for="amazonBucketName">Amazon Bucket Name</label>
            @for (validation of validationMessages.amazonBucketName; track validation) {
              <span>
                @if (form1.get('amazonBucketName').hasError(validation.type) && (form1.get('amazonBucketName').dirty || form1.get('amazonBucketName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="sortOrder" id="sortOrder" type="number" pInputText>
            <label for="sortOrder">Sort Order</label>
            @for (validation of validationMessages.sortOrder; track validation) {
              <span>
                @if (form1.get('sortOrder').hasError(validation.type) && (form1.get('sortOrder').dirty || form1.get('sortOrder').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-calendar formControlName="createDate" inputId="createDate" appendTo="body">
            </p-calendar>
            <label for="createDate">Create Date</label>
            @for (validation of validationMessages.createDate; track validation) {
              <span>
                @if (form1.get('createDate').hasError(validation.type) && (form1.get('createDate').dirty || form1.get('createDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <h6 for="isPicture">Lead Marketing Picture Options</h6>
          <div class="flex align-items-center">
            <p-checkbox [formControl]="form1.controls['leadMarketingPicture']" inputId="leadMarketingPicture" [binary]="true"></p-checkbox>
            <span class="picture-nm">Lead Marketing Picture?</span>
          </div>
          @for (validation of validationMessages.leadMarketingPicture; track validation) {
            <span>
              @if (form1.get('leadMarketingPicture').hasError(validation.type) && (form1.get('leadMarketingPicture').dirty || form1.get('leadMarketingPicture').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>
      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (pictureId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Delete Picture</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!pictureId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()">Add Picture</button>
              }

              @if (pictureId) {
                <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update Picture</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>